import { $API, $SERVER } from "~/util/Loaders";
import { z } from "zod";
import { Upload } from "~/lib/upload.server";

export const uploadImageApi = $API({
  path: "api/upload",
  method: "POST",
  parser: z.object({ pageId: z.number() }).strict(),
})(
  $SERVER?.(async (cx) => {
    const { req } = cx;
    const sess = req.sess;

    if (!sess) {
      return { t: "error" as const, error: "The user is not logged in." };
    }

    try {
      return await Upload(req, cx.input, sess.user.id);
    } catch (err) {
      console.error(err);
      return { t: "error" as const, error: "Failed to save file" };
    }
  })
);
